import "pixi.js";
import BaseComponent from "./BaseComponent";
import Physics from "./Physics";
import C_GameEvt from "./../const/C_GameEvent";
import GameSprite from "./GameSprite";



class EnemyProjectileLogic extends BaseComponent
{


    constructor()
    {
        super();
    }


    postPhysicsUpdate(delta)
    {
        let e = this.getEntity();
        let p = e.getComponent(Physics);

        if (p.position.z < 0)
        {
            let s = e.getComponent(GameSprite);

            if (this.isAccurate)
            {
                p.position.z = 5;
                p.velocity.scale(0);

                s.playEnemyProjectileSplash();

                // console.log(p.position);

                this.app.dispatcher.emit(C_GameEvt.PLAYER_HIT, p.position);
            }
            else
            {
                s.sprite.visible = false;
            }


            this.delayedQueueForRemoval(.5);
        }
    }


}


export default EnemyProjectileLogic;